
import { Fraga } from "@/types/riskbedomning";
import { loadAllFragor } from "./lazy-loader";
import { byggskedeFragorNew } from "./byggskede-new/index";
import { bruksskedeFragor } from "./bruksskede";

// Use lazy loading instead of immediate imports
let cachedFragorData: Fraga[] | null = null;

export const getFragorData = async (): Promise<Fraga[]> => {
  if (cachedFragorData) {
    return cachedFragorData;
  }
  
  cachedFragorData = await loadAllFragor();
  return cachedFragorData;
};

// Synchronous export with actual data for backward compatibility
export const fragorData: Fraga[] = [
  ...byggskedeFragorNew,
  ...bruksskedeFragor
];
